const state = {

  /** Array choix câble */
    coA : [] ,

}
const mutations = {

  /** Ajout au prePanier */
  SET_CHOICE_COA(state, payload) {
    this.newArray
    if( state.coA.length == 0 ){
      this.newArray = payload.coA
    }
    else{
      this.newArray = Object.assign(state.coA, payload.coA);
    }

    state.coA = this.newArray ;
  },
   /** Suppression ligne au prePanier */
   REMOVE_CHOICE_COA(state) {
    state.coA = []
},

}
export default {
    state,
    mutations,
}